import { SUPER_ADMIN_EMAILS } from 'src/app/models/super-admin';

export const environment = {
  production: false,
  mockData: false,
  issuer: 'https://helixopsaiprv.oktapreview.com/oauth2/auswiob1p3HU2waOF1d7',
  clientId: '0oaye5v2w28aYsHXf1d7',
  apiUrl: 'https://acmapiqa.helixops.ai/aca/api/v1/',
  origin: 'https://acmapiqa.helixops.ai',
  cmxClientUrl: 'https://docsqa.helixops.ai/docs/compatibility/#/',
  superAdminsEmails: SUPER_ADMIN_EMAILS,
  tinyMceApiKey: 'o56vwsx2pa9z816lgpgvk1ow7qm55yml4r168ec3ck6n5f5v'
};
